import axios from "axios";

const api = axios.create({
  baseURL: "/",
  responseType: "json",
  timeout: 30_000,
});

api.interceptors.request.use((config) => {
  const csrfToken = (document.querySelector('[name="csrf-token"]') as HTMLMetaElement)?.content;
  const newConfig = config;

  if (csrfToken) {
    newConfig.headers["X-CSRF-Token"] = csrfToken;
  }
  newConfig.headers.Accept = "application/json";
  if (!(newConfig.data instanceof FormData)) {
    newConfig.headers["Content-Type"] = "application/json";
  }
  return newConfig;
});

export { api };
